import Image from 'next/image'
import React from 'react'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Button } from '@/src/domains/design-system/components/Button'
import { Dialog, DialogClose, DialogContent } from '@/src/domains/design-system/components/Dialog'

export interface ClientBookingPlannedEventRebookWarningDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onContinue: () => void
}

export const ClientBookingPlannedEventRebookWarningDialog = ({
  open,
  onOpenChange,
  onContinue,
}: ClientBookingPlannedEventRebookWarningDialogProps) => {
  const { t } = getTranslate()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <div className="text-center">
          <Image
            src="/images/multibooking/preselected.png"
            alt=""
            sizes="148px"
            className="mb-5 mt-6 w-[74px]"
            width={148}
            height={128}
          />
          <h3 className="mb-3 text-xl">{t('component.rebooking.warningDialog.title')}</h3>
          <div className="text-base">{t('component.rebooking.warningDialog.note')}</div>
        </div>
        <div className="mt-10 flex flex-col items-center gap-3 text-lg tablet:mt-5 tablet:flex-row">
          <Button size="medium" className="w-full tablet:w-1/2" onClick={onContinue}>
            {t('component.button.continue')}
          </Button>
          <DialogClose className="w-full border-none bg-transparent p-0 tablet:w-1/2">
            <Button size="medium" variant="secondary" className="w-full">
              {t('component.button.back')}
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  )
}
